import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";

export const ActualizarClassPresupuestaria = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [activo1, setActivo1] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [uno, setUno] = useState();
  const [dos, setDos] = useState();
  const [tres, setTres] = useState();
  const [act, setAct] = useState(false);
  const [act1, setAct1] = useState(true);
  const [act2, setAct2] = useState(true);
  const [act3, setAct3] = useState(true);
  const [cuatro, setCuatro] = useState();
  const [valorto, setValorto] = useState();
  const [values, setValues] = useState({
    idpuc: "",
    descripcion: "",
    puc: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtDescrip = useRef();
  const txt1 = useRef();
  const txt2 = useRef();
  const txt3 = useRef();
  const txt4 = useRef();

  const onChange = (event) => {
    let one;
    let doss;
    let tress;
    let cuatros;
    if (event.target.name === "uno") {
      one = txt1.current.value;
      if (operacion === 2) {
        if (
          (txt1.current.value.substring(0, 1) > 0 &&
            txt1.current.value.substring(1, 2) > 0 &&
            txt1.current.value.substring(2, 3) > 0) ||
          (txt1.current.value.substring(0, 1) > 0 &&
            txt1.current.value.substring(1, 2) === "0" &&
            txt1.current.value.substring(2, 3) === "0") ||
          (txt1.current.value.substring(0, 1) === "0" &&
            txt1.current.value.substring(1, 2) > 0 &&
            txt1.current.value.substring(2, 3) > 0) ||
          (txt1.current.value.substring(0, 1) > 0 &&
            txt1.current.value.substring(1, 2) > 0 &&
            txt1.current.value.substring(2, 3) === "0") ||
          (txt1.current.value.substring(0, 1) === "0" &&
            txt1.current.value.substring(1, 2) === "0" &&
            txt1.current.value.substring(2, 3) > 0) ||
          (txt1.current.value.substring(0, 1) === "0" &&
            txt1.current.value.substring(1, 2) === "0" &&
            txt1.current.value.substring(2, 3) === "0") ||
          (txt1.current.value.substring(0, 1) === "0" &&
            txt1.current.value.substring(1, 2) > 0 &&
            txt1.current.value.substring(2, 3) === "0")
        ) {
          setAct1(false);
          txt2.current.value = "00";
        }
      }
      setUno(one);
      setActivo1(true);
    } else if (event.target.name === "dos") {
      doss = txt2.current.value;
      if (operacion === 2) {
        if (
          (txt2.current.value.substring(0, 1) > 0 &&
            txt2.current.value.substring(1, 2) > 0) ||
          (txt2.current.value.substring(0, 1) === "0" &&
            txt2.current.value.substring(1, 2) > 0) ||
          (txt2.current.value.substring(0, 1) === "0" &&
            txt2.current.value.substring(1, 2) === "0") ||
          (txt2.current.value.substring(0, 1) > 0 &&
            txt2.current.value.substring(1, 2) === "0")
        ) {
          setAct(true);
          setAct2(false);
          txt3.current.value = "00";
        }
      }
      setDos(doss);
    } else if (event.target.name === "tres") {
      tress = txt3.current.value;
      if (operacion === 2) {
        if (
          (txt3.current.value.substring(0, 1) > 0 &&
            txt3.current.value.substring(1, 2) > 0) ||
          (txt3.current.value.substring(0, 1) === "0" &&
            txt3.current.value.substring(1, 2) > 0) ||
          (txt3.current.value.substring(0, 1) === "0" &&
            txt3.current.value.substring(1, 2) === "0") ||
          (txt3.current.value.substring(0, 1) > 0 &&
            txt3.current.value.substring(1, 2) === "0")
        ) {
          setAct1(true);
          setAct3(false);
          txt4.current.value = "00";
        }
      }
      setTres(tress);
    } else if (event.target.name === "cuatro") {
      cuatros = txt4.current.value;
      if (operacion === 2) {
        if (
          (txt4.current.value.substring(0, 1) > 0 &&
            txt4.current.value.substring(1, 2) > 0) ||
          (txt4.current.value.substring(0, 1) === "0" &&
            txt4.current.value.substring(1, 2) > 0) ||
          (txt4.current.value.substring(0, 1) === "0" &&
            txt4.current.value.substring(1, 2) === "0") ||
          (txt4.current.value.substring(0, 1) > 0 &&
            txt4.current.value.substring(1, 2) === "0")
        ) {
          setAct2(true);
          setAct3(true);
          setAct(false);
        }
      }
      setCuatro(cuatros);
    }
  };

  const onNext = (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.name === "uno") {
        txt2.current.focus();
      } else if (event.target.name === "dos") {
        txt3.current.focus();
      } else if (event.target.name === "tres") {
        txt4.current.focus();
      } else if (event.target.name === "cuatro") {
        txtDescrip.current.focus();
      }
    }
  };

  const SeleccionarEfiscal = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var idefiscal = response.data[0].idefiscal;
          var descriptor = response.data[0].descriptor;
          var anio = response.data[0].anio;
          var observaciones = response.data[0].observaciones;
          var statusorg = response.data[0].statusorg;
          var statuspresup = response.data[0].statuspresup;
          var statuspuc = response.data[0].statuspuc;
          var statuscat = response.data[0].statuscat;
          var idorganizacion = response.data[0].idorganizacion;

          localStorage.setItem("idefiscal", idefiscal);
          localStorage.setItem("efiscaldes", descriptor);
          localStorage.setItem("efiscalanio", anio);
          localStorage.setItem("efiseleccionado", true);
          localStorage.setItem("statuspresup", statuspresup);
          localStorage.setItem("statuspuc", statuspuc);
          localStorage.setItem("statuscat", statuscat);
          localStorage.setItem("statusorg", statusorg);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      txt1.current.value.trim() === "" &&
      txt2.current.value === "" &&
      txt3.current.value === "" &&
      txt4.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Clasificador Presupuestario no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txt1.current.focus();
    } else if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Descripción del Clasificador Presupuestario no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/actualizarpuc/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtIdd.current.value),
      descr: txtDescrip.current.value.trim(),
      pu:
        operacion === 1
          ? uno + dos + tres + cuatro
          : operacion === 2 && activo1 === true
          ? uno + dos + tres + cuatro
          : valorto,
      idef: idefiscal,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
            SeleccionarEfiscal();
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idpuc: "",
      descripcion: "",
      puc: "",
    });
    setAct(false);
    setAct1(true);
    setAct2(true);
    setAct3(true);
    setActivate(false);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.puc);
          setValorto(props.puc.puc);
        } else {
          txt1.current.value = "";
          txt2.current.value = "";
          txt3.current.value = "";
          txt4.current.value = "";
          txtDescrip.current.value = "";
          setAct(false);
          setAct1(false);
          setAct2(false);
          setAct3(false);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Agregar Clasificador Presupuestario."
              : operacion === 2
              ? "Editar Clasificador Presupuestario."
              : operacion === 3
              ? "Eliminar Clasificador Presupuestario."
              : "Consultar Clasificador Presupuestario."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} />
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="container row m-0">
                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    ref={txtIdd}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={values ? values.idpuc.trim() : ""}
                    id="inputCedula"
                  />
                </div>
              </div>

              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto col-sm-11">
                <legend className="float-none m-0 w-auto">
                  Clasificador Presupuestario
                </legend>

                <div className="container row m-0 d-flex justify-content-center">
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Ramo:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 ? true : act}
                      maxLength="3"
                      onKeyUp={onNext}
                      name="uno"
                      ref={txt1}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.puc ? props.puc.puc.substring(0, 3) : ""
                      }
                      className="form-control text-uppercase col-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Gen:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={act1}
                      maxLength="2"
                      name="dos"
                      ref={txt2}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.puc ? props.puc.puc.substring(3, 5) : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Espec:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={act2}
                      maxLength="2"
                      name="tres"
                      ref={txt3}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.puc ? props.puc.puc.substring(5, 7) : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      SubEsp:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={act3}
                      maxLength="2"
                      name="cuatro"
                      ref={txt4}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.puc ? props.puc.puc.substring(7, 9) : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                </div>
                <div className="input-group py-1 input-group-sm col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Descripción:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control text-uppercase"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtDescrip}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={values ? values.descripcion.trim() : ""}
                    id="inputDireccion"
                  />
                </div>
              </fieldset>

              <div className="col-md-12 py-2"></div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/presupuesto/modalActualizarClassPuc.js